import { render, staticRenderFns } from "./fileDialog.vue?vue&type=template&id=4135b261&"
import script from "./fileDialog.vue?vue&type=script&lang=js&"
export * from "./fileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports